import React from 'react';
import LocationAnalysis from '../widgets/location-analysis';
import ParticipantAnalysis from '../widgets/participant-analysis';


const SubjectAnalysis = ({
  locationAnalysis,
  paritcipantAnalysis,
  selectedProject,
  sidebarCollapsed,
}) => {
  return (
    <section className="no-wrap-section">
      <LocationAnalysis
        data={locationAnalysis}
        selectedProject={selectedProject}
        showData
      />
      <ParticipantAnalysis
        data={paritcipantAnalysis}
        showData
        selectedProject={selectedProject}
      />
    </section>
  );
}

export default SubjectAnalysis;
